import { Box } from "@mui/material";
import { neutral, Text } from "@flat-ui";
import { BaseProjectProps } from "@custom-types/project-types";
import { AccessLevelDisplayNames } from "@components/access-level/access-level-utils";
import { ProjectActions } from "@components/common/project-actions";
import { getProjectSize } from "@utils/project-utils";
import { ACTION_BTN_SIZE, withEllipsis } from "@styles/common-styles";

/**
 * Bottom section of the card that shows the access level, size, and project actions.
 */
export function ProjectCardBottom({ project }: BaseProjectProps): JSX.Element {
  const accessLevel = AccessLevelDisplayNames[project.accessLevel];
  const size = getProjectSize(project);
  const shouldShowSize = size !== "-";

  return (
    <Box
      component="div"
      sx={{
        paddingTop: 0,
        paddingBottom: 0,
        display: "flex",
        paddingX: "14px",
        alignItems: "center",
        justifyContent: "space-between",
        height: ACTION_BTN_SIZE,
      }}
    >
      <Text
        variant="bodyS"
        sx={{
          color: neutral[700],
          overflow: "hidden",
          minWidth: 0,
          ...withEllipsis,
        }}
      >
        {accessLevel}
        {shouldShowSize && (
          <>
            {" •  "}
            {size}
          </>
        )}
      </Text>

      {/* Show actions on the right side */}
      <ProjectActions project={project} contextType="project-tiles-view" />
    </Box>
  );
}
